module.exports = __webpack_public_path__ + "img/a6bc27f.png";